import { render } from "./PredictabilityScore.vue?vue&type=template&id=51b72778&scoped=true"
import script from "./PredictabilityScore.vue?vue&type=script&lang=js"
export * from "./PredictabilityScore.vue?vue&type=script&lang=js"

import "./PredictabilityScore.vue?vue&type=style&index=0&id=51b72778&scoped=true&lang=css"

import exportComponent from "C:\\Projects\\KneeLeadNew\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51b72778"]])

export default __exports__